<template>
  <div>
    <v-card-title class='pa-0 pl-3 pt-1'>
      <div class="pa-0 px-1 font-weight-bold pt-2 text-h6 primary--text" v-if="!no_title">
        <v-icon color="primary">mdi-cog-outline</v-icon> Operação
      </div>
    </v-card-title>
    <v-card-text class="px-0">
      <div class="ml-4">
        <v-list class="pa-0">
          <v-list-item class="pa-0">
            <v-list-item-avatar><v-icon>mdi-bag-personal-outline</v-icon></v-list-item-avatar>
              <v-list-item-content>
                <div>
                  <v-list-item-title class="font-weight-bold text-subtitle-2 py-1"> Acomodaçao:</v-list-item-title>
                  <v-list-item-subtitle >{{ event_info.has_hotel ? 'Sim' : 'Não' }}</v-list-item-subtitle>
                </div>
                <div v-if="event_info.has_hotel == true">
                  <v-list-item-title class="font-weight-bold text-subtitle-2 py-1"> Custo da despesa:</v-list-item-title>
                  <v-list-item-subtitle >{{ event_info.hotel_by == 'company' ? 'Empresa' : 'Cliente' }}</v-list-item-subtitle>
                </div>
                <div v-if="event_info.hotel_by == 'company'">
                  <v-list-item-title class="font-weight-bold text-subtitle-2 py-1"> Custo de acomodaçao:</v-list-item-title>
                  <v-list-item-subtitle >{{formatMoney(event_info.hotel_value)}}</v-list-item-subtitle>
                </div>
              </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider class="mt-2"></v-divider>
        <v-list class="pa-0">
          <v-list-item class="pa-0">
            <v-list-item-avatar><v-icon>mdi-bus</v-icon></v-list-item-avatar>
              <v-list-item-content>
                <div>
                  <v-list-item-title class="font-weight-bold text-subtitle-2 py-1"> Transporte terrestre:</v-list-item-title>
                  <v-list-item-subtitle >{{ event_info.has_ground_transport ? 'Sim' : 'Não' }}</v-list-item-subtitle>
                </div>
                <div v-if="event_info.has_ground_transport == true">
                  <v-list-item-title class="font-weight-bold text-subtitle-2 py-1"> Custo da despesa:</v-list-item-title>
                  <v-list-item-subtitle >{{ event_info.ground_transport_by == 'company' ? 'Empresa' : 'Cliente' }}</v-list-item-subtitle>
                </div>
                <div v-if="event_info.ground_transport_by == 'company'">
                  <v-list-item-title class="font-weight-bold text-subtitle-2 py-1"> Custo de transporte:</v-list-item-title>
                  <v-list-item-subtitle >{{formatMoney(event_info.ground_transport_value)}}</v-list-item-subtitle>
                </div>
              </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider class="mt-2"></v-divider>
        <v-list class="pa-0">
          <v-list-item class="pa-0">
            <v-list-item-avatar><v-icon>mdi-airplane</v-icon></v-list-item-avatar>
              <v-list-item-content>
                <div>
                  <v-list-item-title class="font-weight-bold text-subtitle-2 py-1"> Transporte aéreo:</v-list-item-title>
                  <v-list-item-subtitle >{{ event_info.has_air_transport ? 'Sim' : 'Não' }}</v-list-item-subtitle>
                </div>
                <div v-if="event_info.has_air_transport == true">
                  <v-list-item-title class="font-weight-bold text-subtitle-2 py-1"> Custo da despesa:</v-list-item-title>
                  <v-list-item-subtitle >{{ event_info.air_transport_by == 'company' ? 'Empresa' : 'Cliente' }}</v-list-item-subtitle>
                </div>
                <div v-if="event_info.air_transport_by == 'company'">
                  <v-list-item-title class="font-weight-bold text-subtitle-2 py-1"> Custo de transporte:</v-list-item-title>
                  <v-list-item-subtitle >{{formatMoney(event_info.air_transport_value)}}</v-list-item-subtitle>
                </div>
              </v-list-item-content>
          </v-list-item>
        </v-list>

        <div class="pa-0 px-1 font-weight-bold pt-2" v-if="event_info.operation_comment">Descrição da operação: </div>
        <div class="pa-0 px-3" v-if="event_info.operation_comment">{{event_info.operation_comment}}</div>  

      </div>
    </v-card-text>
  </div>
</template>
<script>
  export default {
    name: 'SummaryOperation',
    props: {
      event_info: {
        type: Object,
      },
      no_title:{
        type: Boolean,
        default: false,
      }
    },
    methods: {
      formatMoney(entry){
        return Number(entry/100).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>